// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --z-notifications: 2000;
}

.sticky-nav {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
}

.custom-container {
  margin-left: auto;
  margin-right: auto;
  padding-left: 12px;
  padding-right: 12px;
  width: calc(100% - 60px);
  max-width: 1440px;
}

.sdx-link {
  color: var(--sdx-color-int-blue);
  font-weight: 500;
}

.sdx-link:hover {
  color: var(--sdx-color-int-blue--active);
}

.w-full {
  width: 100%;
}

.max-w-full {
  max-width: 100%;
}

.w-half {
  width: 50%;
}

.h-full {
  height: 100%;
}

.h-auto {
  height: auto;
}

.h-screen {
  height: 100vh;
}

.min-h-screen {
  min-height: 100vh;
}

.max-h-full {
  max-height: 100%;
}

.max-h-screen {
  max-height: 100vh;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.-z-1 {
  z-index: -1;
}

.z-0 {
  z-index: 0;
}

.z-10 {
  z-index: 10;
}

.rounded {
  border-radius: calc(var(--sdx-baseline) / 2) !important;
}

.rounded-1 {
  border-radius: var(--sdx-baseline) !important;
}

.rounded-1_5 {
  border-radius: calc(var(--sdx-baseline) * 1.5) !important;
}

.rounded-3 {
  border-radius: calc(var(--sdx-baseline) * 3) !important;
}

.rounded-4 {
  border-radius: calc(var(--sdx-baseline) * 4) !important;
}

.rounded-_20 {
  border-radius: 20px;
}

.rounded-full {
  border-radius: calc(infinity * 1px);
}

.padding-6 {
  padding: calc(var(--sdx-baseline) * 6);
}

.padding-1_5 {
  padding: calc(var(--sdx-baseline) * 1.5);
}

.padding-v-0_5 {
  padding-top: calc(var(--sdx-baseline) / 2);
  padding-bottom: calc(var(--sdx-baseline) / 2);
}

.padding-v-1_5 {
  padding-top: calc(var(--sdx-baseline) * 1.5);
  padding-bottom: calc(var(--sdx-baseline) * 1.5);
}

.padding-v-5 {
  padding-top: var(--sdx-baseline-5);
  padding-bottom: var(--sdx-baseline-5);
}

.padding-v-6 {
  padding-top: var(--sdx-baseline-6);
  padding-bottom: var(--sdx-baseline-6);
}

.padding-v-7 {
  padding-top: calc(var(--sdx-baseline) * 7);
  padding-bottom: calc(var(--sdx-baseline) * 7);
}

.padding-v-8 {
  padding-top: calc(var(--sdx-baseline) * 8);
  padding-bottom: calc(var(--sdx-baseline) * 8);
}

.padding-v-9 {
  padding-top: calc(var(--sdx-baseline) * 9);
  padding-bottom: calc(var(--sdx-baseline) * 9);
}

.padding-right-5 {
  padding-right: var(--sdx-baseline-5);
}

.padding-right-8 {
  padding-right: calc(var(--sdx-baseline) * 8);
}

.padding-left-5 {
  padding-left: var(--sdx-baseline-5);
}

.padding-left-6 {
  padding-left: var(--sdx-baseline-6);
}

.padding-5 {
  padding: var(--sdx-baseline-5);
}

.padding-top-5 {
  padding-top: var(--sdx-baseline-5);
}

.padding-top-6 {
  padding-top: calc(var(--sdx-baseline) * 6);
}

.padding-h-0_5 {
  padding-left: calc(var(--sdx-baseline) / 2);
  padding-right: calc(var(--sdx-baseline) / 2);
}

.padding-h-1_5 {
  padding-left: calc(var(--sdx-baseline) * 1.5);
  padding-right: calc(var(--sdx-baseline) * 1.5);
}

.padding-h-2 {
  padding-left: var(--sdx-baseline-2);
  padding-right: var(--sdx-baseline-2);
}

.padding-h-5 {
  padding-left: var(--sdx-baseline-5);
  padding-right: var(--sdx-baseline-5);
}

.padding-top-8 {
  padding-top: calc(var(--sdx-baseline) * 8) !important;
}

.padding-bottom-5 {
  padding-bottom: var(--sdx-baseline-5);
}

.padding-bottom-8 {
  padding-bottom: calc(var(--sdx-baseline) * 8);
}

.padding-bottom-6 {
  padding-bottom: var(--sdx-baseline-6);
}

.padding-bottom-7 {
  padding-bottom: calc(var(--sdx-baseline) * 7);
}

.padding-top-7 {
  padding-top: calc(var(--sdx-baseline) * 7);
}

.padding-top-9 {
  padding-top: calc(var(--sdx-baseline) * 9);
}

.margin-bottom-0_5 {
  margin-bottom: calc(var(--sdx-baseline) / 2);
}

.margin-bottom-5 {
  margin-bottom: var(--sdx-baseline-5);
}

.margin-bottom-6 {
  margin-bottom: var(--sdx-baseline-6);
}

.margin-bottom-7 {
  margin-bottom: calc(var(--sdx-baseline) * 7);
}

.margin-bottom-8 {
  margin-bottom: calc(var(--sdx-baseline) * 8);
}

.margin-bottom-9 {
  margin-bottom: calc(var(--sdx-baseline) * 9);
}

.margin-bottom-10 {
  margin-bottom: calc(var(--sdx-baseline) * 10);
}

.margin-top-0_5 {
  margin-top: calc(var(--sdx-baseline) / 2);
}

.margin-top-1_5 {
  margin-top: calc(var(--sdx-baseline) * 1.5);
}

.margin-top-5 {
  margin-top: var(--sdx-baseline-5);
}

.margin-top-6 {
  margin-top: calc(var(--sdx-baseline) * 6);
}

.margin-top-7 {
  margin-top: calc(var(--sdx-baseline) * 7);
}

.margin-top-10 {
  margin-top: calc(var(--sdx-baseline) * 10);
}

.margin-negative-1 {
  margin: -1px;
}

.grid {
  display: grid;
}

.subgrid {
  grid-template-columns: subgrid;
  display: grid;
  grid-column: span var(--columns);
}

.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-auto {
  grid-template-columns: repeat(var(--columns), auto);
}

.grid-auto-right {
  grid-template-columns: 1fr auto;
}

.grid-auto-left {
  grid-template-columns: auto 1fr;
}

.grid-min-left {
  grid-template-columns: min-content auto;
}

.grid-min-right {
  grid-template-columns: auto min-content;
}

.grid-auto-between {
  grid-template-columns: min-content auto min-content;
}

.grid-span-2 {
  grid-column: span 2;
}

.grid-span-3 {
  grid-column: span 3;
}

.gap-0_5 {
  gap: calc(var(--sdx-baseline) / 2);
}

.gap-1 {
  gap: var(--sdx-baseline) !important;
}

.gap-1_5 {
  gap: var(--sdx-baseline) !important;
}

.gap-x-1 {
  column-gap: var(--sdx-baseline);
}

.gap-x-2 {
  column-gap: var(--sdx-baseline-2);
}

.gap-x-4 {
  column-gap: var(--sdx-baseline-4);
}

.gap-y-0_5 {
  row-gap: calc(var(--sdx-baseline) / 2);
}

.gap-y-1 {
  row-gap: var(--sdx-baseline);
}

.gap-y-2 {
  row-gap: var(--sdx-baseline-2);
}

.gap-2 {
  gap: var(--sdx-baseline-2) !important;
}

.gap-3 {
  gap: var(--sdx-baseline-3) !important;
}

.gap-4 {
  gap: var(--sdx-baseline-4) !important;
}

.gap-5 {
  gap: var(--sdx-baseline-5);
}

.gap-6 {
  gap: calc(var(--sdx-baseline) * 6) !important;
}

.gap-7 {
  gap: calc(var(--sdx-baseline) * 7) !important;
}

.gap-8 {
  gap: calc(var(--sdx-baseline) * 8) !important;
}

.gap-9 {
  gap: calc(var(--sdx-baseline) * 9) !important;
}

.outline-none {
  outline: 0;
}

.border-none {
  border-width: 0 !important;
}

.border {
  border-width: 1px !important;
  border-style: solid;
}

.border-2 {
  border-width: 2px;
}

.border-dashed {
  border-style: dashed !important;
}

.border-collapse {
  border-collapse: collapse;
}

.border-t {
  border-top-width: 1px;
  border-style: solid;
  border-bottom-width: 0;
  border-left-width: 0;
  border-right-width: 0;
}

.border-v {
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-left-width: 0;
  border-right-width: 0;
}

.border-b {
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-bottom-width: 1px;
  border-style: solid;
}

.border-b-2 {
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-bottom-width: 2px;
  border-style: solid;
}

.border-l {
  border-top-width: 0;
  border-right-width: 0;
  border-bottom-width: 0;
  border-left-width: 1px;
  border-style: solid;
}

.border-r {
  border-top-width: 0;
  border-right-width: 1px;
  border-bottom-width: 0;
  border-left-width: 0;
  border-style: solid;
}

.border-white {
  border-color: #fff;
}

.border-gray {
  border-color: var(--sdx-color-gray);
}

.border-gray-tint-3 {
  border-color: var(--sdx-color-gray-tint-3);
}

.border-gray-tint-4 {
  border-color: var(--sdx-color-gray-tint-4);
}

.border-gray-tint-5 {
  border-color: var(--sdx-color-gray-tint-5);
}

.border-gray-tint-6 {
  border-color: var(--sdx-color-gray-tint-6);
}

.border-gray-tint-7 {
  border-color: var(--sdx-color-gray-tint-7);
}

.border-gray-tint-8 {
  border-color: var(--sdx-color-gray-tint-8);
}

.border-aluminum {
  border-color: var(--sdx-color-aluminum);
}

.border-aluminum-tint-2 {
  border-color: var(--sdx-color-aluminum-tint-2);
}

.border-int-blue {
  border-color: var(--sdx-color-int-blue);
}

.border-int-red {
  border-color: var(--sdx-color-int-red);
}

.border-int-gray {
  border-color: var(--sdx-color-int-gray);
}

.border-transparent {
  border-color: transparent;
}

.border-on-color {
  border-color: rgba(230, 230, 230, 1);
}

.text-decoration-none {
  text-decoration: none;
}

.text-decoration-line-through {
  text-decoration: line-through;
}

.text-large {
  font-size: 22px;
  line-height: 30px;
}

.text-larger {
  font-size: 24px;
  line-height: 32px;
}

.text-center {
  text-align: center;
}

.inline-flex {
  display: inline-flex;
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.flex-auto {
  flex: 1 1 auto;
}

.flex-0 {
  flex: 0 0 auto;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-no-wrap {
  flex-wrap: nowrap;
}

.justify-between {
  justify-content: space-between;
}

.justify-center {
  justify-content: center;
}

.justify-around {
  justify-content: space-around;
}

.justify-start {
  justify-content: start;
}

.justify-end {
  justify-content: end;
}

.items-center {
  align-items: center;
}

.items-start {
  align-items: start;
}

.items-end {
  align-items: end;
}

.items-stretch {
  align-items: stretch;
}

.grow-1 {
  flex-grow: 1;
}

.grow-0 {
  flex-grow: 0;
}

.shrink-0 {
  flex-shrink: 0;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.fixed {
  position: fixed;
}

.sticky {
  position: sticky;
}

.right-0 {
  right: 0;
}

.top-0 {
  top: 0;
}

.left-0 {
  left: 0;
}

.bottom-0 {
  bottom: 0;
}

.absolute-center {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.absolute-center-y {
  top: 50%;
  transform: translateY(-50%);
}

.leading-none {
  line-height: 1em;
}

.leading-3 {
  line-height: var(--sdx-baseline-3);
}

.cursor-default {
  cursor: default;
}

.cursor-pointer {
  cursor: pointer;
}

.pointer-events-none {
  pointer-events: none;
}

.font-normal {
  font-weight: 400;
}

.font-bold {
  font-weight: 600;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-x-auto {
  overflow-x: auto;
}

.overflow-y-auto {
  overflow-y: auto;
}

.no-wrap {
  text-wrap: nowrap;
}

.balanced-wrap {
  text-wrap: balance;
}

.divide-x > :not([hidden]) ~ :not([hidden]) {
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 1px;
  border-right-width: 0px;
  border-style: solid;
}

.divide-y > :not([hidden]) ~ :not([hidden]) {
  border-top-width: 1px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-style: solid;
}

.divide-gray-tint-8 > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--sdx-color-gray-tint-8);
}

.divide-gray-tint-7 > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--sdx-color-gray-tint-7);
}

.divide-int-gray > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--sdx-color-int-gray);
}

.opacity-40 {
  opacity: 0.4;
}

.divide-aluminum > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--sdx-color-aluminum);
}

.rotate-90 {
  transform: rotate(90deg);
}

.rotate-180 {
  transform: rotate(180deg);
}

.rotate-270 {
  transform: rotate(270deg);
}

.flip-x {
  transform: scaleX(-1);
}

.inset-0 {
  inset: 0;
  height: 100%;
  width: 100%;
}

.object-cover {
  object-fit: cover;
}

.object-contain {
  object-fit: contain;
}

.object-center {
  object-position: center;
}

.pre-wrap {
  white-space: pre-wrap;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.hyphens-auto {
  hyphens: auto;
}

.copy {
  hyphens: auto;
  word-break: normal;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  hyphens: auto;
  -webkit-hyphens: auto;
}

/*
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  text-wrap: balance;
} */

.align-middle {
  vertical-align: middle;
}

.skeleton-loader {
  position: relative;
  overflow: hidden;
  background: var(--sdx-color-horizon);
}

.skeleton-loader--light {
  background-color: white;
}

.skeleton-loader::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    var(--sdx-color-horizon),
    var(--sdx-color-horizon-tint-2),
    var(--sdx-color-horizon)
  );
  animation: progress 1.5s ease-in-out infinite;
}

/* .skeleton-loader--light::after {
  background: linear-gradient(90deg, var(--sdx-color-horizon-tint-2), var(--sdx-color-horizon-tint-2)), var(--sdx-color-horizon-tint-2));
} */

.skeleton-loader-light {
  animation: skeleton-loading 1s linear infinite alternate;
}

@keyframes skeleton-loading {
  0% {
    background-color: white;
  }
  100% {
    background-color: #f2f7fa;
  }
}

.origin-center {
  transform-origin: center;
}

@keyframes progress {
  0% {
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}

.snap-start {
  scroll-snap-align: start;
}

.snap-x-mandatory {
  scroll-snap-type: x mandatory;
}

.snap-x-proximity {
  scroll-snap-type: x proximity;
}

.hover-shadow {
  transition: box-shadow 0.2s ease-in-out;
}

.hover-shadow:hover {
  box-shadow: 0 4px 20px 0 rgba(51, 51, 51, 0.16);
}

.shadow-default {
  box-shadow: 0 4px 16px 0px rgba(51, 51, 51, 0.08);
}

.modal-overlay {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 900;
}

.loading-spinner {
  width: 27px;
  height: 27px;
}

.loading-spinner.loading-spinner--large {
  width: 52px;
  height: 52px;
}

.loading-spinner svg {
  width: 100%;
  height: 100%;
  animation: rotate 2s linear infinite;
}

.loading-spinner svg circle {
  fill: none;
  stroke: var(--sdx-color-sc-navy);
  stroke-width: 7px;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

.loading-spinner.loading-spinner--large svg circle {
  stroke-width: 3.634615384615385px;
}

.select-none {
  user-select: none;
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

.slide-animation {
  display: flex;
  animation: slideAnimation 3s infinite ease-in-out;
}

@keyframes slideAnimation {
  0%,
  30% {
    transform: translateX(0%);
  }

  33%,
  63% {
    transform: translateX(-100%);
  }

  66%,
  96% {
    transform: translateX(-200%);
  }

  100% {
    transform: translateX(0%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/utils.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,6CAA6C;AAC/C;;AAEA;;GAEG;;AAEH;EACE,wDAAwD;AAC1D;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[":root {\n  --z-notifications: 2000;\n}\n\n.sticky-nav {\n  position: sticky;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 99;\n}\n\n.custom-container {\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 12px;\n  padding-right: 12px;\n  width: calc(100% - 60px);\n  max-width: 1440px;\n}\n\n.sdx-link {\n  color: var(--sdx-color-int-blue);\n  font-weight: 500;\n}\n\n.sdx-link:hover {\n  color: var(--sdx-color-int-blue--active);\n}\n\n.w-full {\n  width: 100%;\n}\n\n.max-w-full {\n  max-width: 100%;\n}\n\n.w-half {\n  width: 50%;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.h-screen {\n  height: 100vh;\n}\n\n.min-h-screen {\n  min-height: 100vh;\n}\n\n.max-h-full {\n  max-height: 100%;\n}\n\n.max-h-screen {\n  max-height: 100vh;\n}\n\n.block {\n  display: block;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\n.-z-1 {\n  z-index: -1;\n}\n\n.z-0 {\n  z-index: 0;\n}\n\n.z-10 {\n  z-index: 10;\n}\n\n.rounded {\n  border-radius: calc(var(--sdx-baseline) / 2) !important;\n}\n\n.rounded-1 {\n  border-radius: var(--sdx-baseline) !important;\n}\n\n.rounded-1_5 {\n  border-radius: calc(var(--sdx-baseline) * 1.5) !important;\n}\n\n.rounded-3 {\n  border-radius: calc(var(--sdx-baseline) * 3) !important;\n}\n\n.rounded-4 {\n  border-radius: calc(var(--sdx-baseline) * 4) !important;\n}\n\n.rounded-_20 {\n  border-radius: 20px;\n}\n\n.rounded-full {\n  border-radius: calc(infinity * 1px);\n}\n\n.padding-6 {\n  padding: calc(var(--sdx-baseline) * 6);\n}\n\n.padding-1_5 {\n  padding: calc(var(--sdx-baseline) * 1.5);\n}\n\n.padding-v-0_5 {\n  padding-top: calc(var(--sdx-baseline) / 2);\n  padding-bottom: calc(var(--sdx-baseline) / 2);\n}\n\n.padding-v-1_5 {\n  padding-top: calc(var(--sdx-baseline) * 1.5);\n  padding-bottom: calc(var(--sdx-baseline) * 1.5);\n}\n\n.padding-v-5 {\n  padding-top: var(--sdx-baseline-5);\n  padding-bottom: var(--sdx-baseline-5);\n}\n\n.padding-v-6 {\n  padding-top: var(--sdx-baseline-6);\n  padding-bottom: var(--sdx-baseline-6);\n}\n\n.padding-v-7 {\n  padding-top: calc(var(--sdx-baseline) * 7);\n  padding-bottom: calc(var(--sdx-baseline) * 7);\n}\n\n.padding-v-8 {\n  padding-top: calc(var(--sdx-baseline) * 8);\n  padding-bottom: calc(var(--sdx-baseline) * 8);\n}\n\n.padding-v-9 {\n  padding-top: calc(var(--sdx-baseline) * 9);\n  padding-bottom: calc(var(--sdx-baseline) * 9);\n}\n\n.padding-right-5 {\n  padding-right: var(--sdx-baseline-5);\n}\n\n.padding-right-8 {\n  padding-right: calc(var(--sdx-baseline) * 8);\n}\n\n.padding-left-5 {\n  padding-left: var(--sdx-baseline-5);\n}\n\n.padding-left-6 {\n  padding-left: var(--sdx-baseline-6);\n}\n\n.padding-5 {\n  padding: var(--sdx-baseline-5);\n}\n\n.padding-top-5 {\n  padding-top: var(--sdx-baseline-5);\n}\n\n.padding-top-6 {\n  padding-top: calc(var(--sdx-baseline) * 6);\n}\n\n.padding-h-0_5 {\n  padding-left: calc(var(--sdx-baseline) / 2);\n  padding-right: calc(var(--sdx-baseline) / 2);\n}\n\n.padding-h-1_5 {\n  padding-left: calc(var(--sdx-baseline) * 1.5);\n  padding-right: calc(var(--sdx-baseline) * 1.5);\n}\n\n.padding-h-2 {\n  padding-left: var(--sdx-baseline-2);\n  padding-right: var(--sdx-baseline-2);\n}\n\n.padding-h-5 {\n  padding-left: var(--sdx-baseline-5);\n  padding-right: var(--sdx-baseline-5);\n}\n\n.padding-top-8 {\n  padding-top: calc(var(--sdx-baseline) * 8) !important;\n}\n\n.padding-bottom-5 {\n  padding-bottom: var(--sdx-baseline-5);\n}\n\n.padding-bottom-8 {\n  padding-bottom: calc(var(--sdx-baseline) * 8);\n}\n\n.padding-bottom-6 {\n  padding-bottom: var(--sdx-baseline-6);\n}\n\n.padding-bottom-7 {\n  padding-bottom: calc(var(--sdx-baseline) * 7);\n}\n\n.padding-top-7 {\n  padding-top: calc(var(--sdx-baseline) * 7);\n}\n\n.padding-top-9 {\n  padding-top: calc(var(--sdx-baseline) * 9);\n}\n\n.margin-bottom-0_5 {\n  margin-bottom: calc(var(--sdx-baseline) / 2);\n}\n\n.margin-bottom-5 {\n  margin-bottom: var(--sdx-baseline-5);\n}\n\n.margin-bottom-6 {\n  margin-bottom: var(--sdx-baseline-6);\n}\n\n.margin-bottom-7 {\n  margin-bottom: calc(var(--sdx-baseline) * 7);\n}\n\n.margin-bottom-8 {\n  margin-bottom: calc(var(--sdx-baseline) * 8);\n}\n\n.margin-bottom-9 {\n  margin-bottom: calc(var(--sdx-baseline) * 9);\n}\n\n.margin-bottom-10 {\n  margin-bottom: calc(var(--sdx-baseline) * 10);\n}\n\n.margin-top-0_5 {\n  margin-top: calc(var(--sdx-baseline) / 2);\n}\n\n.margin-top-1_5 {\n  margin-top: calc(var(--sdx-baseline) * 1.5);\n}\n\n.margin-top-5 {\n  margin-top: var(--sdx-baseline-5);\n}\n\n.margin-top-6 {\n  margin-top: calc(var(--sdx-baseline) * 6);\n}\n\n.margin-top-7 {\n  margin-top: calc(var(--sdx-baseline) * 7);\n}\n\n.margin-top-10 {\n  margin-top: calc(var(--sdx-baseline) * 10);\n}\n\n.margin-negative-1 {\n  margin: -1px;\n}\n\n.grid {\n  display: grid;\n}\n\n.subgrid {\n  grid-template-columns: subgrid;\n  display: grid;\n  grid-column: span var(--columns);\n}\n\n.grid-cols-6 {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n}\n\n.grid-cols-5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.grid-cols-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.grid-cols-auto {\n  grid-template-columns: repeat(var(--columns), auto);\n}\n\n.grid-auto-right {\n  grid-template-columns: 1fr auto;\n}\n\n.grid-auto-left {\n  grid-template-columns: auto 1fr;\n}\n\n.grid-min-left {\n  grid-template-columns: min-content auto;\n}\n\n.grid-min-right {\n  grid-template-columns: auto min-content;\n}\n\n.grid-auto-between {\n  grid-template-columns: min-content auto min-content;\n}\n\n.grid-span-2 {\n  grid-column: span 2;\n}\n\n.grid-span-3 {\n  grid-column: span 3;\n}\n\n.gap-0_5 {\n  gap: calc(var(--sdx-baseline) / 2);\n}\n\n.gap-1 {\n  gap: var(--sdx-baseline) !important;\n}\n\n.gap-1_5 {\n  gap: var(--sdx-baseline) !important;\n}\n\n.gap-x-1 {\n  column-gap: var(--sdx-baseline);\n}\n\n.gap-x-2 {\n  column-gap: var(--sdx-baseline-2);\n}\n\n.gap-x-4 {\n  column-gap: var(--sdx-baseline-4);\n}\n\n.gap-y-0_5 {\n  row-gap: calc(var(--sdx-baseline) / 2);\n}\n\n.gap-y-1 {\n  row-gap: var(--sdx-baseline);\n}\n\n.gap-y-2 {\n  row-gap: var(--sdx-baseline-2);\n}\n\n.gap-2 {\n  gap: var(--sdx-baseline-2) !important;\n}\n\n.gap-3 {\n  gap: var(--sdx-baseline-3) !important;\n}\n\n.gap-4 {\n  gap: var(--sdx-baseline-4) !important;\n}\n\n.gap-5 {\n  gap: var(--sdx-baseline-5);\n}\n\n.gap-6 {\n  gap: calc(var(--sdx-baseline) * 6) !important;\n}\n\n.gap-7 {\n  gap: calc(var(--sdx-baseline) * 7) !important;\n}\n\n.gap-8 {\n  gap: calc(var(--sdx-baseline) * 8) !important;\n}\n\n.gap-9 {\n  gap: calc(var(--sdx-baseline) * 9) !important;\n}\n\n.outline-none {\n  outline: 0;\n}\n\n.border-none {\n  border-width: 0 !important;\n}\n\n.border {\n  border-width: 1px !important;\n  border-style: solid;\n}\n\n.border-2 {\n  border-width: 2px;\n}\n\n.border-dashed {\n  border-style: dashed !important;\n}\n\n.border-collapse {\n  border-collapse: collapse;\n}\n\n.border-t {\n  border-top-width: 1px;\n  border-style: solid;\n  border-bottom-width: 0;\n  border-left-width: 0;\n  border-right-width: 0;\n}\n\n.border-v {\n  border-top-width: 1px;\n  border-bottom-width: 1px;\n  border-style: solid;\n  border-left-width: 0;\n  border-right-width: 0;\n}\n\n.border-b {\n  border-top-width: 0;\n  border-left-width: 0;\n  border-right-width: 0;\n  border-bottom-width: 1px;\n  border-style: solid;\n}\n\n.border-b-2 {\n  border-top-width: 0;\n  border-left-width: 0;\n  border-right-width: 0;\n  border-bottom-width: 2px;\n  border-style: solid;\n}\n\n.border-l {\n  border-top-width: 0;\n  border-right-width: 0;\n  border-bottom-width: 0;\n  border-left-width: 1px;\n  border-style: solid;\n}\n\n.border-r {\n  border-top-width: 0;\n  border-right-width: 1px;\n  border-bottom-width: 0;\n  border-left-width: 0;\n  border-style: solid;\n}\n\n.border-white {\n  border-color: #fff;\n}\n\n.border-gray {\n  border-color: var(--sdx-color-gray);\n}\n\n.border-gray-tint-3 {\n  border-color: var(--sdx-color-gray-tint-3);\n}\n\n.border-gray-tint-4 {\n  border-color: var(--sdx-color-gray-tint-4);\n}\n\n.border-gray-tint-5 {\n  border-color: var(--sdx-color-gray-tint-5);\n}\n\n.border-gray-tint-6 {\n  border-color: var(--sdx-color-gray-tint-6);\n}\n\n.border-gray-tint-7 {\n  border-color: var(--sdx-color-gray-tint-7);\n}\n\n.border-gray-tint-8 {\n  border-color: var(--sdx-color-gray-tint-8);\n}\n\n.border-aluminum {\n  border-color: var(--sdx-color-aluminum);\n}\n\n.border-aluminum-tint-2 {\n  border-color: var(--sdx-color-aluminum-tint-2);\n}\n\n.border-int-blue {\n  border-color: var(--sdx-color-int-blue);\n}\n\n.border-int-red {\n  border-color: var(--sdx-color-int-red);\n}\n\n.border-int-gray {\n  border-color: var(--sdx-color-int-gray);\n}\n\n.border-transparent {\n  border-color: transparent;\n}\n\n.border-on-color {\n  border-color: rgba(230, 230, 230, 1);\n}\n\n.text-decoration-none {\n  text-decoration: none;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through;\n}\n\n.text-large {\n  font-size: 22px;\n  line-height: 30px;\n}\n\n.text-larger {\n  font-size: 24px;\n  line-height: 32px;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.inline-flex {\n  display: inline-flex;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-auto {\n  flex: 1 1 auto;\n}\n\n.flex-0 {\n  flex: 0 0 auto;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.flex-no-wrap {\n  flex-wrap: nowrap;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-around {\n  justify-content: space-around;\n}\n\n.justify-start {\n  justify-content: start;\n}\n\n.justify-end {\n  justify-content: end;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.items-start {\n  align-items: start;\n}\n\n.items-end {\n  align-items: end;\n}\n\n.items-stretch {\n  align-items: stretch;\n}\n\n.grow-1 {\n  flex-grow: 1;\n}\n\n.grow-0 {\n  flex-grow: 0;\n}\n\n.shrink-0 {\n  flex-shrink: 0;\n}\n\n.relative {\n  position: relative;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.sticky {\n  position: sticky;\n}\n\n.right-0 {\n  right: 0;\n}\n\n.top-0 {\n  top: 0;\n}\n\n.left-0 {\n  left: 0;\n}\n\n.bottom-0 {\n  bottom: 0;\n}\n\n.absolute-center {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.absolute-center-y {\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.leading-none {\n  line-height: 1em;\n}\n\n.leading-3 {\n  line-height: var(--sdx-baseline-3);\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.pointer-events-none {\n  pointer-events: none;\n}\n\n.font-normal {\n  font-weight: 400;\n}\n\n.font-bold {\n  font-weight: 600;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-x-auto {\n  overflow-x: auto;\n}\n\n.overflow-y-auto {\n  overflow-y: auto;\n}\n\n.no-wrap {\n  text-wrap: nowrap;\n}\n\n.balanced-wrap {\n  text-wrap: balance;\n}\n\n.divide-x > :not([hidden]) ~ :not([hidden]) {\n  border-top-width: 0px;\n  border-bottom-width: 0px;\n  border-left-width: 1px;\n  border-right-width: 0px;\n  border-style: solid;\n}\n\n.divide-y > :not([hidden]) ~ :not([hidden]) {\n  border-top-width: 1px;\n  border-bottom-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-style: solid;\n}\n\n.divide-gray-tint-8 > :not([hidden]) ~ :not([hidden]) {\n  border-color: var(--sdx-color-gray-tint-8);\n}\n\n.divide-gray-tint-7 > :not([hidden]) ~ :not([hidden]) {\n  border-color: var(--sdx-color-gray-tint-7);\n}\n\n.divide-int-gray > :not([hidden]) ~ :not([hidden]) {\n  border-color: var(--sdx-color-int-gray);\n}\n\n.opacity-40 {\n  opacity: 0.4;\n}\n\n.divide-aluminum > :not([hidden]) ~ :not([hidden]) {\n  border-color: var(--sdx-color-aluminum);\n}\n\n.rotate-90 {\n  transform: rotate(90deg);\n}\n\n.rotate-180 {\n  transform: rotate(180deg);\n}\n\n.rotate-270 {\n  transform: rotate(270deg);\n}\n\n.flip-x {\n  transform: scaleX(-1);\n}\n\n.inset-0 {\n  inset: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.object-cover {\n  object-fit: cover;\n}\n\n.object-contain {\n  object-fit: contain;\n}\n\n.object-center {\n  object-position: center;\n}\n\n.pre-wrap {\n  white-space: pre-wrap;\n}\n\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.line-clamp-1 {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n}\n\n.line-clamp-2 {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.hyphens-auto {\n  hyphens: auto;\n}\n\n.copy {\n  hyphens: auto;\n  word-break: normal;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  hyphens: auto;\n  -webkit-hyphens: auto;\n}\n\n/*\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  text-wrap: balance;\n} */\n\n.align-middle {\n  vertical-align: middle;\n}\n\n.skeleton-loader {\n  position: relative;\n  overflow: hidden;\n  background: var(--sdx-color-horizon);\n}\n\n.skeleton-loader--light {\n  background-color: white;\n}\n\n.skeleton-loader::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    var(--sdx-color-horizon),\n    var(--sdx-color-horizon-tint-2),\n    var(--sdx-color-horizon)\n  );\n  animation: progress 1.5s ease-in-out infinite;\n}\n\n/* .skeleton-loader--light::after {\n  background: linear-gradient(90deg, var(--sdx-color-horizon-tint-2), var(--sdx-color-horizon-tint-2)), var(--sdx-color-horizon-tint-2));\n} */\n\n.skeleton-loader-light {\n  animation: skeleton-loading 1s linear infinite alternate;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-color: white;\n  }\n  100% {\n    background-color: #f2f7fa;\n  }\n}\n\n.origin-center {\n  transform-origin: center;\n}\n\n@keyframes progress {\n  0% {\n    transform: translate3d(-100%, 0, 0);\n  }\n  100% {\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n.snap-start {\n  scroll-snap-align: start;\n}\n\n.snap-x-mandatory {\n  scroll-snap-type: x mandatory;\n}\n\n.snap-x-proximity {\n  scroll-snap-type: x proximity;\n}\n\n.hover-shadow {\n  transition: box-shadow 0.2s ease-in-out;\n}\n\n.hover-shadow:hover {\n  box-shadow: 0 4px 20px 0 rgba(51, 51, 51, 0.16);\n}\n\n.shadow-default {\n  box-shadow: 0 4px 16px 0px rgba(51, 51, 51, 0.08);\n}\n\n.modal-overlay {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 900;\n}\n\n.loading-spinner {\n  width: 27px;\n  height: 27px;\n}\n\n.loading-spinner.loading-spinner--large {\n  width: 52px;\n  height: 52px;\n}\n\n.loading-spinner svg {\n  width: 100%;\n  height: 100%;\n  animation: rotate 2s linear infinite;\n}\n\n.loading-spinner svg circle {\n  fill: none;\n  stroke: var(--sdx-color-sc-navy);\n  stroke-width: 7px;\n  stroke-linecap: round;\n  animation: dash 1.5s ease-in-out infinite;\n}\n\n.loading-spinner.loading-spinner--large svg circle {\n  stroke-width: 3.634615384615385px;\n}\n\n.select-none {\n  user-select: none;\n}\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.slide-animation {\n  display: flex;\n  animation: slideAnimation 3s infinite ease-in-out;\n}\n\n@keyframes slideAnimation {\n  0%,\n  30% {\n    transform: translateX(0%);\n  }\n\n  33%,\n  63% {\n    transform: translateX(-100%);\n  }\n\n  66%,\n  96% {\n    transform: translateX(-200%);\n  }\n\n  100% {\n    transform: translateX(0%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
